import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import simpleLoading from 'simple-loading';
import { Option } from 'next/javascripts/components/select-list';

Component('tr-todo-copyform', {
  mixins: [eventListenerMixin],

  ready() {
    this.selectProjects = this.querySelector('.select-projects');
    this.selectList = this.querySelector('.select-lists');
    this.initSelectList();
    this.selectProjects.addEventListener('tr-combo-select-field:change', this.initSelectList.bind(this));

    $(this).on('ajax:beforeSend', this.handleFormBeforeSend.bind(this));
  },

  initSelectList() {
    const projectGuid = this.selectProjects.getValue();
    const { selectedOptions } = this.selectProjects;
    const { listName } = this.selectList.dataset;
    if (!projectGuid || !selectedOptions) return;

    if (!projectGuid) return;
    if (this.selectTodo) this.cleanSelectTodo();

    $.ajax({
      url: `/projects/${projectGuid}/lists/uncompleted/`,
      type: 'get',
      dataType: 'json',
      success: (result) => {
        const options = result.map(o => new Option(o.label, o.guid, { 'search-key': `${o.label}${o.key}` }));
        this.selectList.reset();
        this.selectList.dataProvider.options = options;
        this.selectList.list.setOptions(options);
        const shouldSelected = options.filter(option => option.text === listName);
        if (shouldSelected) this.selectList.selectOption(shouldSelected[0]);

        if (this.selectTodo) this.initSelectTodo();
      },
    });
  },

  handleFormBeforeSend() {
    const $form = $('.form-todo-copy');
    const $input = $form.find('#todo-copy-count');
    const field = $input.get(0).querySelector('.mdc-text-field');
    const value = $input.get(0).getValue();
    let valid = true;

    if (!value) {
      field.classList.add('mdc-text-field--invalid');
      valid = false;
    } else if (!/^\d+$/.test(value)) {
      field.classList.add('mdc-text-field--invalid');
      valid = false;
    } else if (parseInt(value, 10) > 50) {
      field.classList.add('mdc-text-field--invalid');
      valid = false;
    }

    if (valid) {
      simpleLoading({
        type: 'global',
        msg: '正在复制任务，请耐心等待...',
      });
    } else {
      const $btn = $form.find('button[type=submit]');
      $btn
        .text($btn.data('ujs:enableWith'))
        .prop('disabled', false)
        .trigger('blur');
      return valid;
    }

    return valid;
  },
});
